export default __webpack_public_path__ + "static/media/labelbg.54c8ee1d.png";